<template>
  <div class="business-stage-div">
    <div
      class="height300 mt20"
      v-if="detail.changeStatus === 2"
    >
      <h3 class="text-flex"  v-if="detail.businessStatus === 1">
        <span>商机已输单</span>
      </h3>
      <h3 class="text-flex" style="flex-direction:row;"  v-else>
        <span>{{detail.changeTypeDesc}}商机</span>
        <el-button class="ml5" type="primary" size="mini" v-if="detail.canRecoveryFlag" @click="recoveryBusiness">恢复</el-button>
      </h3>
      <el-form label-width="100px" style="width:400px;margin:0 auto;">
        <el-form-item label="变更原因:" prop="planName">
          {{detail.changeReason}}
        </el-form-item>
      </el-form>
    </div>
    <ApproveDialog ref="approveDialogRef" @success="refresh" :detail="detail"></ApproveDialog>
  </div>
</template>

<script>
import {
  changeBusinessStage,
  saveCompleteStageItems,
  recovery
} from "@/api/crm/business";
import ApproveDialog from "@/views/crm/business/approveDialog";

export default {
  name: "BusinessStage",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  components: {
    ApproveDialog
  },
  data() {
    return {};
  },
  watch: {
    detail(detail) {
    }
  },
  methods: {
      handleApprove(){
          this.$refs.approveDialogRef.open()
      },
      recoveryBusiness(){
        let that = this
        that.$confirm('确认恢复该商机吗？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          recovery({
            id: this.detail.id
          }).then(response => {
            that.$emit('success')
            this.msgSuccess("恢复成功");
          }).catch(error => {
            loading.close()
          })
        })
      },
      refresh() {
        this.$emit('success')
      }
  }
};
</script>

<style lang='scss' scoped>
.text-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.height300 {
  height: 300px;
}
.business-stage-div {
  .business-stage {
    .stage-button-wrap {
      width: 100%;
      border-bottom-right-radius: 50px;
      border-top-right-radius: 50px;
    }

    .el-button {
      cursor: default;
    }
  }

  .business-stage-btn {
    .el-button--primary {
      background-color: #07aae2;
      border-color: #07aae2;
    }

    .el-button--primary:hover {
      background-color: #06bdf9;
      border-color: #06bdf9;
    }
  }

  .winTips {
    margin-bottom: 30px;
  }
}
</style>
